import {Grid, Menu} from "antd";
import type {ItemType} from "antd/es/menu/interface";

interface NavBarProps {
  menuItems: ItemType[];
  selectedKey: string;
}

function NavBar({menuItems, selectedKey}: NavBarProps) {
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();

  return (
      <>
        {!screens.md ? (
            <div className={"flex flex-1 min-w-0"}/>
        ) : (
            <Menu
                mode="horizontal"
                className={"flex-1 min-w-0"}
                selectedKeys={[selectedKey]}
                items={menuItems}
            />
        )}
      </>
  );
}

export default NavBar;
